import React from 'react';
import { Link } from 'react-static';
import styled from 'styled-components';
import em from 'polished/lib/helpers/em';

const ProgramNavigationWrapper = styled.div`
  list-style: none;
  margin-bottom: 5em;
  // margin-bottom: 0;
  
  a  {
    position: relative;
    display: inline-block;
    padding: 0 1em;
    
    h2 {
      transition-property: color;
      transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
      transition-duration: 100ms;
      display: inline-block;
      padding-bottom: ${em(0.5, 6)};
    }
    
    &:hover {
      h2 {
        color: ${props => props.theme.highlightColor};
      }
    }
    
    &::after {
      font-size: 6em;
      content: '/';
      position: relative;
      padding-left: ${em(2, 6)};
    }
    
    &:last-child {
      &::after {
        display: none;
      }
    }
    
    &.active {
      h2 {
        // text-decoration: underline;
        border-bottom: ${em(0.4, 6)} solid ${props => props.theme.highlightColor};
      }
    }
  }
  
  @media (max-width: 800px) {
    a {
      h2, &::after {
        font-size: ${60 / (800 * 0.01)}vw;
      }
    }
  }
`;

interface Props {
  programPageNavigation: ProgramPageNavigation;
}

interface State {

}

export class ProgramNavigation extends React.Component<Props, State> {
  render() {
    const {
      programPageNavigation,
    }: any = this.props;

    return (
      <ProgramNavigationWrapper>
        {programPageNavigation && programPageNavigation.map((item: ProgramPageNavigationItem, key: number) => (
          <Link to={item.link} key={key}>
            <h2>
              {item.title}
            </h2>
          </Link>
        ))}
      </ProgramNavigationWrapper>
    );
  }
}


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/navigation/ProgramNavigation.tsx